'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from 'react';
import CardSwap, { Card, CardSwapRef } from '@/components/CardSwap';
import { IconButton } from '@/components/ui/button';
import { SanityImage } from '../SanityImage';
export type PromptingSliderType = {
  tip: {
    title: string;
    description: string;
  };
  bullets: string[];
  example: string;
  image: {
    asset: {
      _id: string;
      url: string;
      metadata: {
        lqip: string;
        dimensions: {
          width: number;
          height: number;
          aspectRatio: number;
        };
      };
    };
    alt: string;
  };
};
export function PromptSlider(t0) {
  const $ = _c(51);
  const {
    slidesContent
  } = t0;
  const [index, setIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [direction, setDirection] = useState("right");
  const cardSwapRef = useRef(null);
  if (!slidesContent?.length) {
    return null;
  }
  let t1;
  if ($[0] !== buttonsDisabled || $[1] !== slidesContent.length) {
    t1 = () => {
      if (buttonsDisabled || cardSwapRef.current?.isAnimating()) {
        return;
      }
      setButtonsDisabled(true);
      setAnimating(true);
      setDirection("left");
      cardSwapRef.current?.swapPrev();
      setTimeout(() => {
        setIndex(i => (i - 1 + slidesContent.length) % slidesContent.length);
        setAnimating(false);
      }, 500);
      setTimeout(() => setButtonsDisabled(false), 1500);
    };
    $[0] = buttonsDisabled;
    $[1] = slidesContent.length;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handlePrev = t1;
  let t2;
  if ($[3] !== buttonsDisabled || $[4] !== slidesContent.length) {
    t2 = () => {
      if (buttonsDisabled || cardSwapRef.current?.isAnimating()) {
        return;
      }
      setButtonsDisabled(true);
      setAnimating(true);
      setDirection("right");
      cardSwapRef.current?.swapNext();
      setTimeout(() => {
        setIndex(i_0 => (i_0 + 1) % slidesContent.length);
        setAnimating(false);
      }, 500);
      setTimeout(() => setButtonsDisabled(false), 1500);
    };
    $[3] = buttonsDisabled;
    $[4] = slidesContent.length;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleNext = t2;
  const currentSlide = slidesContent[index];
  let t3;
  if ($[6] !== buttonsDisabled || $[7] !== handlePrev) {
    t3 = <IconButton onClick={handlePrev} iconSize={40} ariaLabel={"Zur\xFCck"} icon="chevron-left-rounded" iconColor="#492e19" hoverIconColor="#db761c" variant="ghost" disabled={buttonsDisabled} />;
    $[6] = buttonsDisabled;
    $[7] = handlePrev;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = index + 1;
  let t5;
  if ($[9] !== t4) {
    t5 = <span className="bg-(--color-granite) rounded-2xl w-10 h-10 flex items-center justify-center text-(--color-softLinen) font-bold">{t4}</span>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== buttonsDisabled || $[12] !== handleNext) {
    t6 = <IconButton onClick={handleNext} iconSize={40} ariaLabel="Weiter" icon="chevron-left-rounded" iconColor="#492e19" hoverIconColor="#db761c" variant="ghost" className="rotate-180" disabled={buttonsDisabled} />;
    $[11] = buttonsDisabled;
    $[12] = handleNext;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className="flex justify-evenly gap-8 w-full">{t3}{t5}{t6}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = `
                            px-2 sm:px-6 lg:px-10 mt-10 flex flex-col gap-2
                            transition-all duration-500
                            ${animating ? direction === "right" ? "translate-x-12 sm:translate-x-20 opacity-0" : "-translate-x-12 sm:-translate-x-20 opacity-0" : "translate-x-0 opacity-100"}
                        `;
  let t9;
  if ($[18] !== currentSlide.tip.title) {
    t9 = <h3 className="mb-1 text-center">{currentSlide.tip.title}</h3>;
    $[18] = currentSlide.tip.title;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== currentSlide.tip.description) {
    t10 = <p className="text-justify">{currentSlide.tip.description}</p>;
    $[20] = currentSlide.tip.description;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== currentSlide.bullets) {
    t11 = currentSlide.bullets.map(_temp);
    $[22] = currentSlide.bullets;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <ul className="list-disc ml-6 mb-2">{t11}</ul>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== currentSlide.example) {
    t13 = <p className="font-bold text-justify">{currentSlide.example}</p>;
    $[26] = currentSlide.example;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t13 || $[31] !== t8 || $[32] !== t9) {
    t14 = <div className={t8}>{t9}{t10}{t12}{t13}</div>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
    $[31] = t8;
    $[32] = t9;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  const t15 = currentSlide.image.asset.metadata?.lqip ? "blur" : "empty";
  const t16 = currentSlide.image.asset.metadata?.lqip;
  let t17;
  if ($[34] !== currentSlide.image.alt || $[35] !== currentSlide.image.asset.url || $[36] !== t15 || $[37] !== t16) {
    t17 = <div className="relative w-full h-[34vh] sm:h-[42vh] mt-6 lg:hidden"><SanityImage src={currentSlide.image.asset.url} className="object-cover rounded-lg" fill={true} alt={currentSlide.image.alt} sizes="100vw" placeholder={t15} blurDataURL={t16} /></div>;
    $[34] = currentSlide.image.alt;
    $[35] = currentSlide.image.asset.url;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t14 || $[40] !== t17 || $[41] !== t7) {
    t18 = <div className="w-full lg:w-1/2 relative overflow-hidden flex flex-col items-center mt-10">{t7}{t14}{t17}</div>;
    $[39] = t14;
    $[40] = t17;
    $[41] = t7;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      perspective: "1200px"
    };
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== slidesContent) {
    t20 = slidesContent.map(_temp2);
    $[44] = slidesContent;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t20) {
    t21 = <div className="hidden lg:block w-full lg:w-1/2 min-w-0"><div className="relative w-full h-[70vh]" style={t19}><CardSwap ref={cardSwapRef} cardDistance={80} verticalDistance={60} delay={0} pauseOnHover={false}>{t20}</CardSwap></div></div>;
    $[46] = t20;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t18 || $[49] !== t21) {
    t22 = <div className="w-full max-w-350 mx-auto"><div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-12">{t18}{t21}</div></div>;
    $[48] = t18;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  return t22;
}
function _temp2(slide, i_2) {
  return <Card key={i_2}><SanityImage src={slide.image.asset.url} className="object-cover rounded-lg" fill={true} alt={slide.image.alt} sizes="50vw" placeholder={slide.image.asset.metadata?.lqip ? "blur" : "empty"} blurDataURL={slide.image.asset.metadata?.lqip} /></Card>;
}
function _temp(b, i_1) {
  return <li key={i_1}>{b}</li>;
}